<template>
  <div>
    <div>
      <span>{{ completion.optionContent }}</span>
    </div>

    <div class="form-input">
      <label class="labelStyle" style="width: 100px;">现场监测值:</label>
      <input
        v-model="completion.value"
        type="number"
        class="input"
        @input="onInput"
      />
      <span>{{completion.unit}}</span>
    </div>
    <div class="form-input">
      <label class="labelStyle" style="width: 100px;">质控设备监测值:</label>
      <input
        v-model="completion.theoryValue"
        type="number"
        class="input"
        @input="onInput"
      />
      <span>{{completion.unit}}</span>
    </div>
    <div class="form-input">
      <label>偏差:</label>
      <span v-if="!Number.isFinite(realValue) || !Number.isFinite(theoryValue)" class="diff">--</span>
      <span
        v-else-if="isPercentage"
        :style="{ color: isQualified ? 'green' : 'red' }"
        class="diff"
        >{{ (completion.resultValue * 100).toFixed(2) }}%</span
      >
      <span
        v-else
        :style="{ color: isQualified ? 'green' : 'red' }"
        class="diff"
        >{{ completion.resultValue.toFixed(2) }}{{completion.unit}}</span
      >
    </div>
  </div>
</template>

<script>
import BaseFormula from '../BaseFormula'

export default {
  name: 'WindSpeed',
  extends: BaseFormula,
  getSelected: opt =>
    `理论值:${opt.theoryValue}, 实测值:${opt.value}`,
  computed: {
    theoryValue () {
      let theoryValue = this.completion.theoryValue
      return typeof theoryValue === 'number' ? theoryValue : theoryValue ? Number(theoryValue) : null
    },
    realValue () {
      let realValue = this.completion.value
      return typeof realValue === 'number' ? realValue : realValue ? Number(realValue) : null
    },
    isPercentage () {
      return this.theoryValue >= 5 || this.realValue >= 5
    },
    threshold () {
      return this.isPercentage ? 0.02 : 0.25
    },
    isCompleted () {
      return (
        typeof this.theoryValue === 'number' &&
        typeof this.realValue === 'number'
      )
    },
    isQualified () {
      return this.compare(
        Math.abs(Number(this.completion.resultValue)),
        this.threshold
      )
    }
  },
  methods: {
    setParam () {
      let completion = this.completion
      completion.isCompleted = this.isCompleted
      completion.isQualified = this.isQualified
    },
    onInput () {
      let { theoryValue, realValue } = this
      let diff = realValue - theoryValue
      this.completion.resultValue =
        this.isPercentage
          ? Number(diff / theoryValue)
          : Number(diff)
      this.setParam()
      this.$emit('complete-change')
    }
  },
  created () {
    this.setParam()
  }
}
</script>

<style lang="scss" scoped>
.form-input {
  margin-top: 5px;
}

.input {
  margin-left: 10px;
}

.diff {
  margin-left: 22px;
}

.labelStyle {
  display:inline-block;
  text-align: justify;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/Formula/WindSpeed.vue